import http from '@/communication/AuthConnection'

export default ({ commit, state }) => {
  const itemId = state.selectedItem._id
  http.post(`/v1/unquote`, { itemId })
    .then((quotePayload) => {
      state.list.map((item, idx) => {
        if (item._id === quotePayload.data._id) {
          const itemIndex = idx
          const itemData = item
          itemData.quote = null
          itemData.itemQuoted = null
          item.status = 0
          commit('UPDATE_ITEM', { itemIndex, itemData })
          commit('SET_SELECTED_ITEM', { itemDetail: itemData })
        }
      })
    })
}



// WEBPACK FOOTER //
// ./src/brain/item-association/UnquoteItem.js